<template>
  <div id="tipsThree"></div>
</template>

<script>
export default {
  name: "TipsThree",
  props: {
    data: {
      type: Object,
      required: true,
      default: () => ({
        title: "5 LinkedIn Tips",
        items: [
          "Post consistently at peak hours",
          "Use carousels for higher reach",
          "Reply to every comment",
        ],
        chip: "Tips",
      }),
    },
    scale: {
      type: Number,
      required: true,
      default: 0.8,
    },
  },
  computed: {
    workspace() {
      return this.$store.state.workspace;
    },
  },
  mounted() {
    this.render();
  },
  watch: {
    scale: {
      handler() {
        this.render();
      },
      immediate: true,
      deep: true,
    },
    data: {
      handler() {
        this.render();
      },
      deep: true,
    },
  },
  methods: {
    render() {
      const el = document.getElementById("tipsThree");
      if (!el) return;
      el.innerHTML = this.exportHTML();
    },
    exportHTML(exporting = false) {
      const containerSize = exporting ? 1200 : 1200 * this.scale;
      const titleSize = exporting ? 54 : 54 * this.scale;
      const itemSize = exporting ? 34 : 34 * this.scale;
      const numberSize = exporting ? 80 : 80 * this.scale;
      const logoHeight = exporting ? 45 : 45 * this.scale;
      const chipSize = exporting ? 18 : 18 * this.scale;

      const logoSrc = this.workspace?.branding?.logo?.dark || "";
      const primaryColor =
        this.workspace?.branding?.color?.primary || "#e63946";

      const items = this.data.items || [];
      const itemsHtml = items
        .map(
          (item, index) => `
        <div style="display: flex; align-items: flex-start; margin-bottom: 32px;">
          <div style="
            font-size: ${numberSize}px;
            font-family: 'Playfair Display', 'Georgia', serif;
            font-weight: 900;
            color: #1a1a1a;
            opacity: 0.1;
            line-height: 1;
            margin-right: 24px;
            min-width: ${numberSize}px;
            flex-shrink: 0;
          ">${index + 1}</div>
          <div style="
            font-size: ${itemSize}px;
            font-weight: 500;
            color: #1a1a1a;
            line-height: 1.4;
            padding-top: 16px;
            font-family: 'Inter', 'Helvetica Neue', sans-serif;
          ">${item}</div>
        </div>
      `,
        )
        .join("");

      let openingDiv = `<div style="height: ${containerSize}px; width: ${containerSize}px; aspect-ratio: 1 / 1;">`;

      let html = `
        ${openingDiv}
        <div
          style="
            background-color: #fafafa;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            height: 100%;
            width: 100%;
            aspect-ratio: 1 / 1;
            position: relative;
            overflow: hidden;
          "
        >
          <!-- Header with logo -->
          <div style="padding: 8%; position: relative; z-index: 1;">
            <img src="${logoSrc}" height="${logoHeight}px" alt="" />
          </div>

          <!-- Tips content -->
          <div style="padding: 0 8% 8% 8%; position: relative; z-index: 1;">
            <div style="margin-bottom: 40px;">
              <p style="
                font-size: ${titleSize}px;
                font-family: 'Playfair Display', 'Georgia', serif;
                font-weight: 700;
                color: #1a1a1a;
                line-height: 1.2;
                margin: 0;
                display: inline-block;
                position: relative;
              ">
                ${this.data.title}
                <span style="
                  position: absolute;
                  bottom: -8px;
                  left: 0;
                  width: 60%;
                  height: 4px;
                  background: ${primaryColor};
                "></span>
              </p>
            </div>

            <div>
              ${itemsHtml}
            </div>

            <!-- Chip -->
            <div style="display: flex; margin-top: 16px;">
              <span
                style="
                  display: inline-block;
                  background: #1a1a1a;
                  color: #ffffff;
                  font-size: ${chipSize}px;
                  font-weight: 600;
                  border-radius: 4px;
                  padding: 12px 20px;
                  letter-spacing: 0.08em;
                  text-transform: uppercase;
                  font-family: 'Inter', 'Helvetica Neue', sans-serif;
                "
              >
                ${this.data.chip}
              </span>
            </div>
          </div>
        </div>
      </div>
      `;

      return html;
    },
  },
};
</script>

<style>
@import url("https://fonts.googleapis.com/css2?family=Playfair+Display:wght@600;700;900&display=swap");
</style>
